/**
 * @generated SignedSource<<80194167a2b6b35a47d29145ca6d75c1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs, Result } from "relay-runtime";
export type backofficeUiPreferencesFragment$data = {
  readonly backofficeUiPreference: Result<{
    readonly data: string;
  } | null, unknown>;
  readonly " $fragmentType": "backofficeUiPreferencesFragment";
};
export type backofficeUiPreferencesFragment$key = {
  readonly " $data"?: backofficeUiPreferencesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"backofficeUiPreferencesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "backofficeUiPreferencesFragment",
  "selections": [
    {
      "kind": "CatchField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "BackofficeUiPreferenceApiDto",
        "kind": "LinkedField",
        "name": "backofficeUiPreference",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "data",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      "to": "RESULT"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "16aa0d3378a82a20e8840d533edb195f";

export default node;
